import React, { useEffect, useRef } from "react";

import { Select } from "@chakra-ui/react";
import MapboxGeocoder from "@mapbox/mapbox-gl-geocoder";
import mapboxgl from "mapbox-gl";
import "@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css";
import "mapbox-gl/dist/mapbox-gl.css";

import { useAppDispatch, useAppSelector } from "store/store";
import { actions } from "store/user/reducer";

interface IProps {
	setCoordinates: (coordinates: [number, number]) => void;
	value?: [number, number];
}

const accessToken = "pk.eyJ1IjoiZGh1YiIsImEiOiJjbGUyczIyODQwMXdrM3dseG53MnMxaXI4In0.FYGuulRoBvKZ56vsbIXpzA";

const getStyleUrl = (style: string) => {
	switch (style) {
		case "satellite":
			return "mapbox://styles/mapbox/satellite-v9";
		default:
			return "mapbox://styles/dhub/cl2ypoavr000z14n5af53rj77";
	}
};

export const Mapbox: React.FC<IProps> = (props) => {
	const { setCoordinates, value } = props;
	const mapContainerRef = useRef<HTMLDivElement>(null);
	const mapRef = useRef<mapboxgl.Map | null>(null);
	const markerRef = useRef<mapboxgl.Marker | null>(null);
	const mapStyle = useAppSelector((state) => state.user.mapStyle);
	const dispatch = useAppDispatch();

	// Inicializar mapa
	useEffect(() => {
		if (!mapContainerRef.current) return;

		const map = new mapboxgl.Map({
			container: mapContainerRef.current,
			style: getStyleUrl(mapStyle),
			accessToken,
			center: [(value && value[0]) || -3, (value && value[1]) || 40],
			zoom: value ? 7 : 3,
		});

		mapRef.current = map;

		const geocoder = new MapboxGeocoder({
			accessToken,
			placeholder: "Search for location",
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
			mapboxgl: mapboxgl as any,
		});

		map.addControl(geocoder);

		map.on("click", (e) => {
			setCoordinates([e.lngLat.lng, e.lngLat.lat]);
		});

		if (value) {
			markerRef.current = new mapboxgl.Marker({ color: "#718096", scale: 0.6 }).setLngLat(value).addTo(map);
		}

		return () => {
			map.remove();
			mapRef.current = null;
			markerRef.current = null;
		};
	}, []);

	// Actualizar estilo cuando cambia mapStyle
	useEffect(() => {
		mapRef.current?.setStyle(getStyleUrl(mapStyle));
	}, [mapStyle]);

	// Actualizar marcador cuando cambia value
	useEffect(() => {
		if (!mapRef.current) return;
		if (value) {
			if (markerRef.current) {
				markerRef.current.setLngLat(value);
			} else {
				markerRef.current = new mapboxgl.Marker({ color: "#718096", scale: 0.6 })
					.setLngLat(value)
					.addTo(mapRef.current);
			}
		} else if (markerRef.current) {
			markerRef.current.remove();
			markerRef.current = null;
		}
	}, [value]);

	return (
		<div>
			<Select defaultValue="default" my=".5rem" onChange={(e) => dispatch(actions.setStyle(e.target.value))}>
				<option value="default">Vista mapa</option>
				<option value="satellite">Vista satélite</option>
			</Select>
			<div ref={mapContainerRef} style={{ width: "100%", height: "30rem", borderRadius: "0.375rem" }} />
		</div>
	);
};
